import { PlatformLocation } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, TemplateRef, ViewChild } from '@angular/core';

import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { interval, Subscription } from 'rxjs';
import swal from 'sweetalert2';
import { CookieService } from '../shared/services/cookie-service';
import { TemplateService } from '../shared/services/template.service';

export type HeaderType = 'header-default' | 'header-primary' | 'header-info' | 'header-success' | 'header-danger' | 'header-dark';
export type SideNavType = 'sidenav-default' | 'side-nav-dark';

@Component({
    selector: 'app-associate-layout',
    templateUrl: "./associate-layout.component.html",
    encapsulation: ViewEncapsulation.None,
    styleUrls: [ "../../assets/css/associate-override.css" ]
})
export class AssociateLayoutComponent implements OnInit {

  @ViewChild("slickModal") slickModal: SlickCarouselComponent;

    headerThemes = ['header-default', 'header-primary', 'header-info', 'header-success', 'header-danger', 'header-dark'];
    sidenavThemes = ['sidenav-default', 'side-nav-dark'];
    headerSelected: HeaderType;
    sidenavSelected: SideNavType;
    isCollapse: boolean;
    rtlActived: boolean = false;
    audiochat: boolean = false;
    videochat: boolean = false;
    audiochatMin: boolean = false;
    videochatMin: boolean = false;
    toggleNotesFlag: boolean = false;
    themeConfigOpen: boolean = false;
    attachmentReview: boolean = false;
    zoomStatus: boolean = false;
    vcallStatus: boolean = false;
    loggedProfile: any;
    subscription: Subscription;
    accountExpiredFlag: boolean = false;

    modalRef: BsModalRef;

    slides = [
      {img: "https://dummyimage.com/600x400/a8a8a8/fff.jpg&text=Placehoder+-+1"},
      {img: "https://dummyimage.com/600x400/a8a8a8/fff.jpg&text=Placehoder+-+2"},
      {img: "https://dummyimage.com/600x400/a8a8a8/fff.jpg&text=Placehoder+-+3"},
      {img: "https://dummyimage.com/600x400/a8a8a8/fff.jpg&text=Placehoder+-+4"},
      {img: "https://dummyimage.com/600x400/a8a8a8/fff.jpg&text=Placehoder+-+5"},
      {img: "https://dummyimage.com/600x400/a8a8a8/fff.jpg&text=Placehoder+-+6"},
      {img: "https://dummyimage.com/600x400/a8a8a8/fff.jpg&text=Placehoder+-+7"}
    ];

    thumbnailsSlider = {
      speed:300,
      slidesToShow:3,
      slidesToScroll:1,
      cssEase:'linear',
      autoplay: false,
      // centerMode:true,
      arrows: false,
      draggable:false,
      focusOnSelect:true,
      asNavFor:".feedback",
      "infinite": false
    };

    slideConfig = {
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "infinite": false,
      prevArrow: '<div class="slick-prev" id="click-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
      nextArrow: '<div class="slick-next" id="click-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
      asNavFor:".thumbs"
    };

    config = {
      ignoreBackdropClick: false,
    };

    constructor(

      private _cookie: CookieService,
      private tplSvc: TemplateService,
      private router: Router,
      private cookieService: CookieService,
      private modalService: BsModalService,
      location: PlatformLocation) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                //console.log('here')
                //    this.checkSessionCookies();


                const browserRefresh = !router.navigated;
                const routerNavigated = router.navigated;

                // Max 5 min left or session expired and then user refresh the browser
                if (browserRefresh && cookieService.checkLoginCookies()) {
                    if ((300000 >= (new Date(JSON.parse(localStorage.getItem('ExpireTime'))).getTime() - new Date().getTime())) || (new Date().getTime() > new Date(JSON.parse(localStorage.getItem('ExpireTime'))).getTime())) {
                        this.cookieService.logOutCookies();
                        this.router.navigate(['/account/sign-in']);
                    }
                }

                // Cookie time will extend on navigation & refreshing browser
                if (browserRefresh || routerNavigated) {
                    if (cookieService.checkLoginCookies()) {
                        this.loggedProfile = this.cookieService.GetCookies('loggeduser');
                        if (((new Date(JSON.parse(localStorage.getItem('ExpireTime'))).getTime() - new Date().getTime())) > 300000) {
                            this.cookieService.SetCookies('loggeduser', JSON.stringify(this.loggedProfile));
                        }
                        this.subscription = interval(1).subscribe((val) => {
                            if (cookieService.checkLoginCookies()) {
                                if (cookieService.isExpiringPopupShow == false) {
                                    if ((300000 >= (new Date(JSON.parse(localStorage.getItem('ExpireTime'))).getTime() - new Date().getTime())) && (new Date(JSON.parse(localStorage.getItem('ExpireTime'))).getTime() > new Date().getTime())) {
                                        this.cookieService.expiringSession();
                                    }
                                }
                            }
                            if (cookieService.isExpiredPopupShow == false && cookieService.isLoggedOut == false) {
                                if (new Date(JSON.parse(localStorage.getItem('ExpireTime'))).getTime() < new Date().getTime() && cookieService.isCloseExpiredPopup == false) {
                                    this.cookieService.expireSession();
                                }
                            }
                        });
                    }

                    // Browser's back pressed event
                    location.onPopState(() => {
                        if (cookieService.isExpiredPopupShow || cookieService.isExpiringPopupShow) {
                            swal.close();
                            this.cookieService.logOutCookies();
                            this.router.navigate(['/account/sign-in']);
                        }
                    });
                  }
                }
        });
    }

    ngOnInit() {
        this.tplSvc.isSideNavCollapseChanges.subscribe(isCollapse => this.isCollapse = isCollapse);
    }

    onPopState(event) {
      if (this.accountExpiredFlag) {
          window.history.forward();
          console.log('Account Expired cant go back');
      }
  }

    changeHeader(headerTheme: HeaderType) {
        this.headerSelected = headerTheme;
    }

    changeSidenav(sidenavTheme: SideNavType) {
        this.sidenavSelected = sidenavTheme;
    }

    toggleThemeConfig() {
        this.themeConfigOpen = !this.themeConfigOpen;
    }

    checkSessionCookies() {
        const lu = this._cookie.GetCookies('loggeduser');
        if (lu == '') {
            window.location.href = "/account/sign-in";
        }
    }

    openSiderbar(){
        document.getElementById('siderbar-chatlist').classList.toggle('showlist');
    }

    closeSidebar(){
      document.getElementById('siderbar-chatlist').classList.remove('showlist');
    }

    minimizeWin(event:any){
      let getdm = event.target.parentNode.parentNode.parentNode.nextElementSibling;
      event.target.parentNode.classList.toggle('minmode-active')

      if(getdm.style.display == 'block'){
        getdm.style.display = 'none';
      }
      else {
        getdm.style.display = "block";
      }
    }

    closeWin(event){
      let getdm = event.target.parentNode.parentNode.parentNode.parentNode.parentNode;
      getdm.style.display = 'none';
      event.stopPropagation();
    }

    createChatwin(name) {
      let dynright = 60;
      let chatwinHtml: any = "<div class='live-chat-box' style='right:"+dynright+"px'><div class='box box-primary direct-chat direct-chat-primary'> <div class='box-header with-border'> <h3 class='box-title'>"+ name +" <span data-toggle='tooltip' title='' class='badge' data-original-title='3 New Messages'>3</span></h3> <div class='box-tools pull-right'> <button type='button' class='btn btn-box-tool p-0' id='minimize-win' > <i class='ti-minus minimize-win'></i> </button> <button type='button' class='btn btn-box-tool close-win p-0'><i class='ti-close'></i></button> </div></div><div class='elm-height' style='display:block'> <div class='header-bottom'> <p class='m-0 small text-white'>Mark the issue as?</p><button class='btn btn-xs btn-success m-0 mr-2'>Resolved</button> <button class='btn btn-xs btn-info m-0'>Pending</button> </div><div class='box-body'> <div class='direct-chat-messages'> <div class='direct-chat-msg'> <div class='direct-chat-info clearfix'> <span class='direct-chat-timestamp pull-right'>2:00 PM</span> </div><h5 class='direct-chat-img'>A</h5> <div class='direct-chat-text'> <p> Hi!</p></div></div><div class='direct-chat-msg right'> <div class='direct-chat-info clearfix'> <span class='direct-chat-timestamp pull-left'>2:05 PM</span> </div><img class='direct-chat-img' src='../../assets/images/user.jpg' alt='Message User Image'> <div class='direct-chat-text'> <p> Welcome! Alexander, How may i help you?</p></div></div><div class='direct-chat-msg'> <div class='direct-chat-info clearfix'> <span class='direct-chat-timestamp pull-right'>2:06 PM</span> </div><h5 class='direct-chat-img'>A</h5> <div class='direct-chat-text'> <p>I want to know about your product and it's pricing.</p></div></div><div class='direct-chat-msg right'> <div class='direct-chat-info clearfix'> <span class='direct-chat-timestamp pull-left'>2:07 PM</span> </div><img class='direct-chat-img' src='../../assets/images/user.jpg' alt='Message User Image'> <div class='direct-chat-text'> <p> Lorem Ipsum, sometimes referred to as 'lipsum'.</p><p> Price is $20.00</p></div></div></div></div><div class='box-footer'> <form action='#' method='post' autocomplete='off'><div class='d-flex align-items-center'><input type='text' name='message' autocomplete='off' placeholder='Type Message ...' class='form-control'> <button type='submit' class='btn btn-primary-copy m-0'> <img src='../../assets/images/icon_send.svg' alt=''></button></div></form></div></div></div></div>";
      //let chatwinHtml:any = "<div class='live-chat-box' style='margin-right:"+dynright+"px'><iframe src=''></iframe></div>"
      var e = document.createElement('div');
      e.innerHTML = chatwinHtml;

      while(e.firstChild) {
        document.getElementById('chatwin-cnt').appendChild(e.firstChild);
      }

      var minimizelink =  document.getElementsByClassName('minimize-win');
       for (var i = 0; i < minimizelink.length; i++) {
        var link = minimizelink[i];
        link.addEventListener('click', this.minimizeWin);
      }

      var closelink =  document.getElementsByClassName('close-win');
       for (var i = 0; i < closelink.length; i++) {
        var link = closelink[i];
        link.addEventListener('click', this.closeWin);
      }

    }

    openAudioModal(event){
      event.target.parentNode.parentNode.remove();
      this.audiochat = !this.audiochat;
    }

    openVideoModal(event){
      event.target.parentNode.parentNode.remove();
      this.videochat = !this.videochat;
    }

    rejectCall(event){
      event.target.parentNode.parentNode.remove();
    }

    minimizeCall(){
      this.audiochatMin = !this.audiochatMin;
    }

    toggleNotes(){
      this.toggleNotesFlag = !this.toggleNotesFlag;
      document.getElementById('call-notes').classList.toggle('d-none');
    }

    vcallStatusModal(){
      this.vcallStatus = !this.vcallStatus;
      this.videochat = !this.videochat;

    }

    openAttachment(){
      this.attachmentReview = !this.attachmentReview;
    }



    zoominZoomout(){

      var zmStatus = this.zoomStatus;

      this.zoomStatus = !this.zoomStatus;
      this.slickModal.unslick();
      this.slickModal.initSlick();

        if(zmStatus === true){
          document.getElementById('click-next').click();
        }
    }
}
